module.exports = __webpack_public_path__ + "static/media/card_brand_diners.87c3e398.svg";